import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Job } from 'src/models/jobs/job.model';
import { LocationModel } from 'src/models/locations/location.model';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';
import { LocationMultiControl } from './LocationMultiControl';

export const JobLocationMultiControl = (): React.ReactElement => {
    const defaultCountryCode = useRootSelector(state => state.configuration.value.countryCode);
    const { setValue, getValues } = useFormContext<Pick<Job, 'locations'>>();
    const value = getValues('locations');

    const onChange = useCallback(
        (data: LocationModel[]) => {
            setValue('locations', data);
        },
        [setValue]
    );

    return (
        <>
            <div className="mb-1">Locations</div>
            <LocationMultiControl
                onChange={onChange}
                defaultCountryCode={defaultCountryCode}
                defaultValues={value}
            />
        </>
    );
};
